const ArrowIcon = (props) => (
<svg {...props} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M10.4773 6.16396L6.00732 1.69396L7.18565 0.515625L13.6673 6.99729L7.18565 13.479L6.00732 12.3006L10.4773 7.83062H0.333984V6.16396H10.4773Z" fill={props.fill ?? "#616778"} />
</svg>
);

export default ArrowIcon;
